import {
  Dispatch,
  Fragment,
  ReactElement,
  SetStateAction,
  useState,
} from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, Grid } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CardnetLogo from "../../../../assets/images/cardnetLogo.png";
import TransferenciaLogo from "../../../../assets/images/transferenciaLogo.png";
import CheckRender from "../../../../components/CheckRender/CheckRender";
import COLORS from "../../../../theme/Colors";
import {
  BankContainer,
  BorderLinearProgress,
  ModalBody,
  ModalTitle,
  PaymentButton,
  PaymentButtonImage,
} from "./styles/PaymentModalStyles";
import PopularLogo from "../../../../assets/images/popularLogo.webp";
import BanreservasLogo from "../../../../assets/images/banreservasLogo.png";
import BHDLogo from "../../../../assets/images/bhdLogo.png";
import { StyledButton } from "../../../../theme/Styles";
import UploadFile from "../../../../components/UploadFile";
import DropZone from "../../../../components/drop-zone";

interface Props {
  loadingPercent: number;
  onUploadVoucherClick: () => void;
  onCardnetClick: () => void;
  showDialogModal: boolean;
  setShowDialogModal: Dispatch<SetStateAction<boolean>>;
  setSelectedFile: (file: unknown) => void;
  selectedFile: unknown;
}

const PaymentModal = ({
  loadingPercent,
  showDialogModal,
  setShowDialogModal,
  setSelectedFile,
  selectedFile,
  onUploadVoucherClick,
  onCardnetClick,
}: Props): ReactElement => {
  const [showDepositView, setShowDepositView] = useState(false);

  const handleClose = () => {
    setShowDepositView(false);
    setShowDialogModal(false);
    setSelectedFile(undefined);
  };

  return (
    <Dialog maxWidth={"xl"} open={showDialogModal}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: showDepositView ? "space-between" : "flex-end",
        }}
      >
        <CheckRender allowed={showDepositView}>
          <IconButton
            sx={{ alignSelf: "flex-end", padding: "16px" }}
            aria-label="close"
            onClick={() => setShowDepositView(false)}
          >
            <ArrowBackIcon sx={{ color: COLORS.primary }} />
          </IconButton>
        </CheckRender>
        <IconButton
          sx={{ alignSelf: "flex-end", padding: "16px" }}
          aria-label="close"
          onClick={() => handleClose()}
        >
          <CloseIcon sx={{ color: COLORS.primary }} />
        </IconButton>
      </div>
      {/* Payment with upload voucher  */}
      <CheckRender allowed={showDepositView}>
        <ModalBody>
          <Grid
            container
            alignContent={"center"}
            alignItems="center"
            direction="row"
            justifyContent={"center"}
            spacing={{ xs: 1, md: 1.5 }}
            columns={{ xs: 4, sm: 12, md: 12 }}
          >
            <Grid item xs={4} sm={6} md={6}>
              <BankContainer>
                <h3>CUENTA EN PESOS</h3>
                <p>
                  <strong>BANCO DE RESERVAS</strong> <br />
                  <strong>NÚMERO:</strong> 9605217985 <br />
                  <strong>RNC:</strong> 430344885 <br />
                  <strong>MONTO:</strong> RD$ 30,000.00 <br />
                  <strong>PRO-AM ( SI APLICA ):</strong> RD$ 30,000.00 <br />
                </p>
                <PaymentButtonImage src={BanreservasLogo} />
              </BankContainer>
            </Grid>

            <Grid item xs={4} sm={6} md={6}>
              <BankContainer>
                <h3>CUENTA EN DÓLARES</h3>
                <p>
                  <strong>BANCO DE RESERVAS</strong> <br />
                  <strong>NÚMERO:</strong> 9605218022 <br />
                  <strong>RNC:</strong> 430344885 <br />
                  <strong>MONTO:</strong> US$ 500.00 <br />
                  <strong>PRO-AM ( SI APLICA ):</strong> US$ 500.00 <br />
                </p>
                <PaymentButtonImage src={BanreservasLogo} />
              </BankContainer>
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            direction="row"
            justifyContent={"space-between"}
            columns={{ xs: 4, sm: 12, md: 12 }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <DropZone
                id="selectedFile"
                // value={selectedFile}
                /*@ts-expect-error types */
                onChange={(e) => setSelectedFile(e.target.value[0])}
              />
            </Grid>

            <Grid item xs={4} sm={12} md={12}>
              <CheckRender
                allowed={loadingPercent !== 0}
                notAllowedReturn={
                  <Fragment>
                    <br />
                    <br />
                  </Fragment>
                }
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box sx={{ width: "100%", mr: 1 }}>
                    <BorderLinearProgress
                      variant="determinate"
                      value={loadingPercent}
                    />
                  </Box>
                  <Box sx={{ minWidth: 35 }}>
                    <p>{loadingPercent}%</p>
                  </Box>
                </Box>
              </CheckRender>
            </Grid>

            <Grid item xs={4} sm={12} md={12}>
              <StyledButton
                disabled={loadingPercent !== 0}
                onClick={() => onUploadVoucherClick()}
                variant="contained"
              >
                Subir comprobante
              </StyledButton>
            </Grid>
          </Grid>
        </ModalBody>
      </CheckRender>
      {/* Payment selection */}
      <CheckRender allowed={!showDepositView}>
        <ModalBody>
          <ModalTitle>Seleccione una forma de pago</ModalTitle>
          <div style={{ flexDirection: "row", display: "flex", gap: 32 }}>
            <PaymentButton onClick={onCardnetClick}>
              <h3>Pago con tarjeta</h3>
              <PaymentButtonImage src={CardnetLogo} />
            </PaymentButton>
            <PaymentButton onClick={() => setShowDepositView(true)}>
              <h3>Transferencia</h3>
              <PaymentButtonImage src={TransferenciaLogo} />
            </PaymentButton>
          </div>
        </ModalBody>
      </CheckRender>
    </Dialog>
  );
};
export default PaymentModal;
